'use client';

import { HeadingText } from '@/components/atoms/HeadingText';
import { Select } from '@/components/atoms/Inputs/Select';
import { useFormContext } from '@/components/forms/FormContext';
import { PictureStepActions } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/steps/PictureStep/state';
import { IconInfoBubble } from '@/components/icons';
import {
	ReplaceVirtuallyFormState,
	StepMap,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import { ReplaceVirtuallyFormActionMap } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/reducer';
import { TextAlert } from '@/components/calculators/TextAlert';

export interface SystemTypeLocationSizeSubStepProps {
	testId?: string;
}

const SystemTypeLocationSizeSubStep = (
	props: SystemTypeLocationSizeSubStepProps,
) => {
	const { testId = 'SystemTypeLocationSizeSubStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>();

	function handleLocationChange(event: React.ChangeEvent<HTMLSelectElement>) {
		dispatch({
			type: PictureStepActions.UPDATE_SYSTEM_LOCATION,
			payload: event.target.value,
		});
	}

	const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		dispatch({
			type: PictureStepActions.UPDATE_MODEL_TYPE,
			payload: event.target.value,
		});
	};

	const handleSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		dispatch({
			type: PictureStepActions.UPDATE_MODEL_SIZE,
			payload: event.target.value,
		});
	};

	return (
		<>
			<div data-testid={testId} className="hvac-container">
				<HeadingText
					tag="h2"
					balanced
					className="mx-auto mb-10 mt-4 max-w-5xl lg:mb-14 lg:mt-14"
				>
					Okay, provide the following information about your HVAC system
				</HeadingText>

				<div className="mx-auto mb-8 grid max-w-101 gap-4 lg:mb-10">
					<Select
						id="modelType"
						name="modelType"
						label="Type"
						value={state.modelType}
						onChange={handleTypeChange}
					>
						<option></option>
						<option value="Heat Pump and Electric Air Handler">
							Heat Pump and Electric Air Handler
						</option>
						<option value="A/C Condenser and Gas Furnace">
							A/C Condenser and Gas Furnace
						</option>
						<option value="Heat Pump and Gas Furnace">
							Heat Pump and Gas Furnace
						</option>
						<option value="A/C Condenser and Boiler/Oil/Radiant Heat">
							A/C Condenser and Boiler/Oil/Radiant Heat
						</option>
						<option value="Mini Split">Mini Split</option>
						<option value="Propane">Propane</option>
						<option value="Geothermal">Geothermal</option>
					</Select>
					<Select
						id="modelSize"
						name="modelSize"
						label="Size of outdoor unit"
						value={state.modelSize}
						onChange={handleSizeChange}
					>
						<option></option>
						<option value="1.5 ton">1.5 ton</option>
						<option value="2.0 ton">2.0 ton</option>
						<option value="2.5 ton">2.5 ton</option>
						<option value="3.0 ton">3.0 ton</option>
						<option value="3.5 ton">3.5 ton</option>
						<option value="4.0 ton">4.0 ton</option>
						<option value="5.0 ton">5.0 ton</option>
					</Select>
					<Select
						id="systemLocation"
						name="systemLocation"
						label="Furnace or air handler location"
						value={state.systemLocation}
						onChange={handleLocationChange}
					>
						<option></option>
						<option value="Basement">Basement</option>
						<option value="Crawlspace">Crawlspace</option>
						<option value="Attic">Attic</option>
						<option value="Closet">Closet</option>
						<option value="Multiple Locations">Multiple Locations</option>
						<option value="Other">Other</option>
						<option value="Not Sure">Not Sure</option>
						<option value="I don't have one">I Don&apos;t Have One</option>
					</Select>
				</div>
				<TextAlert
					id="WhyAsking"
					renderIcon={IconInfoBubble}
					title="Why are we asking?"
					text="Your system details tell us the size and efficiency details we need to maximize quote accuracy and home comfort."
				/>
			</div>
		</>
	);
};

export default SystemTypeLocationSizeSubStep;
